<div class="container">
    <div class="price-top-heading">
        <h5 class="rps-heading-five">Price</h5>
    </div>
    <div class="row" *ngIf="overviewModel?.isETF">
        <div class="col-xs-6 col-md-4 col-sm-4 price-box" *ngIf="overviewModel?.isInternalFund">
            <p class="price-heading rps-paragraph-two">Minimum Investment</p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.marketPrice; else mdash" data-rpa-tag-id="overview-pr-minInvestment">{{1 | currency:'USD':'symbol':'1.2-2'}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-minInvestment">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.marketPrice" data-rpa-tag-id="minInvestmentDate">as of {{ overviewModel?.marketPriceAsOfDate | ESTPipe }}</p>
        </div>

       <div class="col-xs-6 col-md-3 col-sm-4 price-box" *ngIf="overviewModel?.isInternalFund">
            <p class="price-heading rps-paragraph-two"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Market price','',''); priceComponentModal.openModalDialog($event);" href="javascript:void(0)">Market price</a>
            </p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.marketPrice; else mdash" data-rpa-tag-id="overview-pr-mkt-price">{{overviewModel?.marketPrice | currency:'USD':'symbol':'1.2-2'}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-mkt-price">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.marketPrice" data-rpa-tag-id="overview-pr-mkt-price-asOfDate">as of {{ overviewModel?.marketPriceAsOfDate | ESTPipe }}</p>
        </div>

        <div class="col-xs-6 col-md-5 col-sm-4 price-box" *ngIf="overviewModel?.isInternalFund">
            <p class="price-heading rps-paragraph-two ">Market price change</p>
            <div class="price-data-wrap">
              <c11n-icon
                class="value-change-icon"
                data-rpa-tag-id="arrowMarket"
                *ngIf="overviewModel?.marketPriceChangeAmount > 0 || overviewModel?.marketPriceChangeAmount < 0"
                [name]="overviewModel?.marketPriceChangeAmount | valueChange : 'name'"
                [size]="'small'"
                [altText]="overviewModel?.marketPriceChangeAmount | valueChange : 'altText'">
              </c11n-icon>
              <span class="vg-heading-four--regular" *ngIf="overviewModel?.marketPriceChangeAmount; else mdash"
                    data-rpa-tag-id="priceChangeMarket_percentChangeMarket">{{overviewModel?.marketPriceChangeAmount ?
                (overviewModel?.marketPriceChangeAmount| currency:'USD':'symbol':'1.2-2') : '&mdash;'}} ({{overviewModel.marketPriceChangePct | VMFPercent}})
              </span>
            </div>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="priceChangeMarket_percentChangeMarket">&mdash;</h4>
            </ng-template>
            <p class="other-caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.marketPriceChangeAmount" data-rpa-tag-id=“priceChangeDate”>as of {{ overviewModel?.marketPriceAsOfDate | ESTPipe }}</p>
        </div>

        <div class="col-xs-6 col-md-4 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Expense Ratio','',''); priceComponentModal.openModalDialog($event);" href="javascript:void(0)">Expense Ratio<sup>{{expenseRatioFootnote?.id}}</sup></a>
            </p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.expenseRatio; else mdash" data-rpa-tag-id="overview-pr-expenseRatio">{{overviewModel?.expenseRatio | VMFPercent: true}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-expenseRatio">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.expenseRatio" data-rpa-tag-id="overview-pr-expenseRatio-asOfDate">as of {{ overviewModel?.expenseRatioAsOfDate | ESTPipe }}</p>
        </div>

        <div class="col-xs-6 col-md-3 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two">NAV Price</p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.navPrice; else mdash" data-rpa-tag-id="overview-pr-nav-price">{{overviewModel.navPrice | currency:'USD':'symbol':'1.2-2'}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-nav-price">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.navPrice" data-rpa-tag-id="overview-pr-nav-price-asOfDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>

        <div class="col-xs-6 col-md-5 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two">NAV Change</p>
            <div class="price-data-wrap">
              <c11n-icon
                class="value-change-icon"
                data-rpa-tag-id="arrowNAV"
                *ngIf="overviewModel?.isETF && (overviewModel?.navPriceChangeAmount > 0 || overviewModel?.isETF && overviewModel?.navPriceChangeAmount < 0)"
                [name]="overviewModel?.navPriceChangeAmount | valueChange : 'name'"
                [size]="'small'"
                [altText]="overviewModel?.navPriceChangeAmount | valueChange : 'altText'">
              </c11n-icon>
              <span class="vg-heading-four--regular" *ngIf="overviewModel.navPriceChangeAmount; else mdash"
                    data-rpa-tag-id="priceChangeNAV_pricePercentNAV">{{overviewModel?.navPriceChangeAmount ?
                (overviewModel?.navPriceChangeAmount| currency:'USD':'symbol':'1.2-2') : '&mdash;'}} ({{overviewModel.navPriceChangePct | VMFPercent}})
              </span>
            </div>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="priceChangeNAV_pricePercentNAV">&mdash;</h4>
            </ng-template>
            <p class="other-caption rps-paragraph-three rps-grey" *ngIf="overviewModel.navPriceChangeAmount" data-rpa-tag-id="priceChangeDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>

    </div>
    <div class="row" *ngIf="overviewModel?.isMutualFund">
        <div class="col-md-4 order-0 order-sm-0 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two">Minimum Investment</p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.isClosed || overviewModel?.isClosedToNewInvestors; else isMinimum" data-rpa-tag-id="overview-pr-minInvestment">Closed</h4>
            <ng-template #isMinimum>
                <h4 class="price-data vg-heading-four--regular"  *ngIf="overviewModel.minimum && overviewModel.minimum !== 'Not Available'; else mdash" data-rpa-tag-id="overview-pr-minInvestment">{{ overviewModel.minimum | currency:'USD':'symbol':'1.0-0' }}</h4>
                <ng-template #mdash>
                    <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-minInvestment">&mdash;</h4>
                </ng-template>
            </ng-template>
        </div>
        <div class="col-md-3 order-2 order-sm-1 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two">NAV Price</p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.navPrice; else mdash" data-rpa-tag-id="overview-pr-nav-price">{{ overviewModel.navPrice | currency:'USD':'symbol':'1.2-2'}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-nav-price">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.navPrice" data-rpa-tag-id="overview-pr-nav-price-asOfDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>
        <div class="col-md-5 mb-4 order-3 order-sm-2 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two ">NAV change</p>
            <div class="price-data-wrap">
              <c11n-icon
                class="value-change-icon"
                *ngIf="overviewModel?.navPriceChangeAmount > 0 || overviewModel?.navPriceChangeAmount < 0"
                [name]="overviewModel?.navPriceChangeAmount | valueChange : 'name'"
                [size]="'small'"
                [altText]="overviewModel?.navPriceChangeAmount | valueChange : 'altText'">
              </c11n-icon>
              <span class="vg-heading-four--regular" *ngIf="overviewModel?.navPriceChangeAmount; else mdash"
                    data-rpa-tag-id="priceChangeNAV_pricePercentNAV">{{ overviewModel?.navPriceChangeAmount| currency:'USD':'symbol':'1.2-2'}} ({{ overviewModel.navPriceChangePct | VMFPercent}})
              </span>
            </div>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="priceChangeNAV_pricePercentNAV">&mdash;</h4>
            </ng-template>
            <p class="other-caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.navPriceAsOfDate" data-rpa-tag-id="priceChangeDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>
        <div *ngIf="overviewModel?.isInternalFund"class="col-md-4 order-1 order-sm-3 price-box">
            <p class="price-heading rps-paragraph-two " *ngIf="overviewModel?.isFundOfFunds">Acquired fund fees and expenses<sup>{{expenseRatioFootnote?.id}}</sup></p>
            <p class="price-heading rps-paragraph-two" *ngIf="!overviewModel?.isFundOfFunds"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Expense Ratio','',''); priceComponentModal.openModalDialog($event);" href="javascript:void(0)">Expense Ratio<sup>{{expenseRatioFootnote?.id}}</sup></a>
            </p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.expenseRatio; else mdash" data-rpa-tag-id="overview-pr-expenseRatio">{{overviewModel.expenseRatio | VMFPercent:true}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-expenseRatio">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.expenseRatioAsOfDate" data-rpa-tag-id="overview-pr-expenseRatio-asOfDate">as of {{ overviewModel?.expenseRatioAsOfDate | ESTPipe }}</p>
        </div>


        <div *ngIf="overviewModel?.isExternalFund"class="col-md-4 order-1 order-sm-3 price-box">
            <p class="price-heading rps-paragraph-two"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Gross Expense Ratio','',''); priceComponentModal.openModalDialog($event);" href="javascript:void(0)">Gross Expense Ratio</a>
            </p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.expenseRatio; else mdash">{{overviewModel.expenseRatio | VMFPercent:true}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.expenseRatioAsOfDate">as of {{ overviewModel?.expenseRatioAsOfDate | ESTPipe }}</p>
        </div>

        <div *ngIf="overviewModel?.isMoneyMarket" class="col-md-4 order-1 order-sm-4 price-box">
            <p class="price-heading rps-paragraph-two"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Daily market value','',''); priceComponentModal.openModalDialog($event);" href="javascript:void(0)">Daily market value</a>
            </p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.navPrice; else mdash">{{ overviewModel.dailyMarketPrice | currency:'USD':'symbol':'1.4-4'}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.navPrice">as of {{ overviewModel?.dailyMarketAsOfDate | ESTPipe }}</p>
        </div>
    </div>

    <div class="row" *ngIf="overviewModel?.is529">
        <div class="col-md-4 order-0 order-sm-0 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two">Minimum Investment</p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.isClosed || overviewModel?.isClosedToNewInvestors; else isMinimum" data-rpa-tag-id="overview-pr-minInvestment">Closed</h4>
            <ng-template #isMinimum>
                <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel.minimum; else mdash" data-rpa-tag-id="overview-pr-minInvestment">{{ overviewModel.minimum | currency:'USD':'symbol':'1.0-0' }}</h4>
                <ng-template #mdash>
                    <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-minInvestment">&mdash;</h4>
                </ng-template>
                <p class="caption rps-paragraph-three rps-grey">per account</p>
            </ng-template>
        </div>
        <div class="col-md-3 order-2 order-sm-1 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two">Unit Price</p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.navPrice; else mdash" data-rpa-tag-id="overview-pr-nav-price">{{ overviewModel.navPrice | currency:'USD':'symbol':'1.2-2'}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-nav-price">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.navPrice" data-rpa-tag-id="overview-pr-nav-price-asOfDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>
        <div class="col-md-5 order-3 order-sm-2 mb-4 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two ">Unit change</p>
            <div class="price-data-wrap">
              <c11n-icon
                class="value-change-icon"
                data-rpa-tag-id="arrowMarket"
                *ngIf="overviewModel?.navPriceChangeAmount > 0 || overviewModel?.navPriceChangeAmount < 0"
                [name]="overviewModel?.navPriceChangeAmount | valueChange : 'name'"
                [size]="'small'"
                [altText]="overviewModel?.navPriceChangeAmount | valueChange : 'altText'">
              </c11n-icon>
              <span class="vg-heading-four--regular" *ngIf="overviewModel?.navPriceChangeAmount; else mdash"
                    data-rpa-tag-id="priceChangeNAV_pricePercentNAV">{{ overviewModel?.navPriceChangeAmount| currency:'USD':'symbol':'1.2-2'}} ({{ overviewModel.navPriceChangePct | VMFPercent}})
              </span>
            </div>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="priceChangeNAV_pricePercentNAV">&mdash;</h4>
            </ng-template>
            <p class="other-caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.navPriceAsOfDate" data-rpa-tag-id="priceChangeDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>
        <div class="col-md-4 order-1 order-sm-3 col-sm-4 price-box">
            <p class="price-heading rps-paragraph-two"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Expense Ratio','',''); priceComponentModal.openModalDialog($event);" href="javascript:void(0)">Expense Ratio<sup>{{expenseRatioFootnote?.id}}</sup></a>
            </p>
            <h4 class="price-data vg-heading-four--regular" *ngIf="overviewModel?.expenseRatio; else mdash" data-rpa-tag-id="overview-pr-expenseRatio">{{overviewModel.expenseRatio | VMFPercent: true}}</h4>
            <ng-template #mdash>
                <h4 class="price-data vg-heading-four--regular" data-rpa-tag-id="overview-pr-expenseRatio">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" *ngIf="overviewModel?.expenseRatioAsOfDate" data-rpa-tag-id="overview-pr-expenseRatio-asOfDate">as of {{ overviewModel?.expenseRatioAsOfDate | ESTPipe }}</p>
        </div>
    </div>
</div>
<c11n-modal-dialog
  modalId="priceComponentModal"
  [headingText]="dialogTitle"
  #priceComponentModal
>
  <div c11n-modal-dialog-body>
    <ng-container *ngTemplateOutlet="simpleDialogContent"></ng-container>
  </div>
</c11n-modal-dialog>
<ng-template #simpleDialogContent>
  <div>
    <p class="rps-paragraph-three" *ngIf="!SecyieldFlag">{{dialogBody}}</p>
    <p class="rps-paragraph-one" *ngIf="SecyieldFlag" [innerHTML]="dialogBody"></p>
  </div>
</ng-template>
